export default __webpack_public_path__ + "static/media/logisticGreen.fffc31f0.svg";